import type { FormikValues } from "formik";
import type { ID, Option } from "types";
import { MOR } from "consts/general";
import { getOptionById, getOptionName } from "util/option";
import { compareIds, when } from "util/support";
import type { User } from "features/users/types";
import { isEmployee, isMerchant, isMors } from "features/auth/helpers";

export const isRoleEnabled = (userRoleName?: User['roleName']) =>
    !isEmployee(`${userRoleName}`);

export const isMerchantRequired = (roles: Array<Option>) => (roleId: Option['id']) => {
    const roleOption = getOptionById(roles, roleId);
    return isMerchant(getOptionName(roleOption));
};

export const isDomainRequired = (roles: Array<Option>) => (roleId: Option['id']) => {
    const roleOption = getOptionById(roles, roleId);

    return isMors(getOptionName(roleOption));
};

export const isMerchantEnabled = (roles: Array<Option>, userRoleName?: User['roleName']) =>
    ({ roleId }: FormikValues) => Boolean(
        roleId &&
        isRoleEnabled(userRoleName) &&
        isMerchantRequired(roles)(roleId)
    );

export const isMorEnabled = (roles: Array<Option>, userRoleName?: User['roleName']) =>
({ roleId }: FormikValues) =>
    Boolean(
        roleId &&
        isRoleEnabled(userRoleName)&&
        isDomainRequired(roles)(roleId)

    );
export const getDomainsOptions = (roles: Option[], domainOptions: Option[]) =>
    ({ roleId }: FormikValues) => {
        const roleOption = getOptionById(roles, roleId);

        return when(
            isMors(getOptionName(roleOption)),
            () => domainOptions.filter(item => compareIds(item.id, MOR.Default)),
            domainOptions
        );
    };

export const isMorMultiple = (_?: ID | null) => false;

export const isMerchantMultiple = (roles: Array<Option>, { roleId }: FormikValues) => {
    const roleOption = getOptionById(roles, roleId);
    return !isMerchant(getOptionName(roleOption))
}
